module.exports = __webpack_public_path__ + "fonts/DM_Sans-400-latin-ext1.cc0d7bc.woff2";